//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.DisplayResolutionBuilder.js";
import "../Validate/Validate.SelectionAndPlacementBuilder.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"Angle",1,0],[0,"AutomaticUpdate",1,0],[1,"DisplayResolutionBuilder",0,"GeometricUtilities.DisplayResolutionBuilder",0],[0,"DrawOrientation",1,1],[0,"DrawOrigin",1,1],[0,"ExceedExtendToleranceColor",1,0],[0,"ExtendedAngularTolerance",1,0],[0,"LessThanMaxAngleColor",1,0],[0,"MoreThanMaxAngleColor",1,0],[0,"OverhangArea",0,0],[0,"PreviewState",1,0],[1,"SelectionAndPlacement",0,"Validate.SelectionAndPlacementBuilder",0],[0,"ShowOnlyExceedingOverhangAngles",1,1],[0,"ShowOnlyFailArea",1,0]],[[["nTargets"],"GetTargets",{R_:{targets:"Body[]"}},0,1],[["targets"],"SetTargets",{},1,1],[[],"Update",{},0,0]],[]];
SPLM.Validate.CheckMaximumOverhangAngleBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.CheckMaximumOverhangAngleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;